import { render, staticRenderFns } from "./CallLog.vue?vue&type=template&id=f8272c3c&scoped=true"
import script from "./CallLog.vue?vue&type=script&lang=js"
export * from "./CallLog.vue?vue&type=script&lang=js"
import style0 from "./CallLog.vue?vue&type=style&index=0&id=f8272c3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8272c3c",
  null
  
)

export default component.exports